import { UI, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Button } from 'native-base';
import React from 'react';

interface SubscriptionDetailsHeaderProps {
  isMobile: boolean;
  onReturn: () => void;
}

export const SubscriptionDetailsHeader: React.FC<SubscriptionDetailsHeaderProps> = ({
  isMobile,
  onReturn,
}) => {
  if (isMobile) {
    return (
      <HStack alignItems="center" justifyContent={'space-between'}>
        <Button
          p={0}
          testID="return-button"
          size="lg"
          variant="textLink"
          leftIcon={<UI.Icon name="ArrowLeft" size="xxs" color={Color['neutral.black']} />}
          justifyContent="start"
          onPress={onReturn}
          _text={{
            color: Color['neutral.black'],
            textTransform: 'initial',
            pl: Spacing['inline.nano'],
            fontSize: Typography['fontsize.lg'],
          }}>
          Detalhes de Subscrição
        </Button>
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between" w="full">
      <HStack alignItems="center" space="inline.xxxs">
        <UI.IconButton
          icon="ArrowLeft"
          testId="return-button"
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
          shadow={3}
          variant="link"
          onPress={onReturn}
        />
        <UI.Heading testId="qa" size="h2">
          Detalhes de Subscrição
        </UI.Heading>
      </HStack>
    </HStack>
  );
};
